import FetchRequest from "@/api/FetchRequest";
class ChatGtpUserApi {
    //基础url
    static url = "/vim/assistant";
   
    /**
      * 新增助手
      * @param  Id 助手ID
      * 
      */
    static AddChatGtpUser(id: string): Promise<any> {
        const data={
            id:id
        }
        
        return FetchRequest.post(this.url ,JSON.stringify(data) , true);
    }
     /**
      * 查询助手列表
      * 
      * 
      */
     static QueryGtpUser(pageNum: number, pageSize: number,): Promise<any> {
      
        return FetchRequest.get(this.url+'/list'+ '?pageNum=' + pageNum + '&pageSize=' + pageSize ,true, false);
    }
}
export default ChatGtpUserApi;